<template>
  <div>
    <!-- nav class="navbar fixed-top navbar-expand-sm navbar-dark bg-dark">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#nav-content" aria-controls="nav-content" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <Brand>
      <a class="navbar-brand" href="#"><img src="https://getbootstrap.com/assets/brand/bootstrap-solid.svg" width="30" height="30" alt="Logo"></a>

      <Links>
      <div class="collapse navbar-collapse" id="nav-content">
        <ul class="navbar-nav">
          <li class="nav-item"> <a class="nav-link" href="#">Sobre</a></li>
          <li class="nav-item"> <a class="nav-link" href="#">Galeria</a></li>
          <li class="nav-item"> <a class="nav-link" href="#">Contato</a></li>
          <li class="nav-item"> <a class="nav-link" href="#">Outros</a></li>
        </ul>
      </div>
    </nav -->

    <div class="row page-header mt-4">
      <div class="col">
        <h1>Biriweb</h1>

        <h3>Faça Login</h3>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <form v-on:submit.prevent="signIn">
              <div class="form-group">
                <label for="inputUsername">Usuário</label>
                <input type="text" class="form-control" id="inputUsername" autocomplete="username" aria-describedby="emailHelp" v-model="username" ref="username">
              </div>
              <div class="form-group">
                <label for="inputPass">Senha<span v-if="error_message != ''"> ({{error_message}})</span></label>
                <input type="password" class="form-control" id="inputPass" autocomplete="current-password" v-model="password">
              </div>
              <button type="submit" class="btn btn-primary">Entrar</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: () => {
    return {
      username: '',
      password: '',
      error_message: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      // this.$refs.username.focus()
    })
  },
  methods: {
    signIn: function() {
      let successCallback = (response) => {
        if (response.body.data && response.body.data.token) {

          let expire_at = new Date((new Date).getTime() + 10*60000);

          this.$cookies.set('api_token', response.body.data.token, expire_at)
          this.$cookies.set('user_name', response.body.data.user_name, expire_at)
          this.$cookies.set('user_email', response.body.data.user_email, expire_at)
          this.$cookies.set('business_id', response.body.data.business_id, expire_at)

          this.$router.push({ path: '/' })
        } else {
          this.password = ''
          this.error_message = 'Login/senha incorretos'
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      this.$http.post(`${this.$root.base_url}/sign_in`, { username: this.username, password: this.password }).then(successCallback, errorCallback)
    }
  },
  metaInfo: {
    style: [
      { cssText: 'body { background-color: #323273; }', type: 'text/css' }
    ]
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Login.vue